import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';
import styles from './ConditionForm.module.scss';
import Select from 'component/atom/forms/select/select/Select';
import Input from 'component/atom/forms/input/input/Input';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import { useBrandingContext } from 'app-context/BrandingsContext';
import Toggle from 'component/atom/forms/toggle/Toggle';
import Button from 'component/atom/forms/button/Button';
import { useWorkflowContext } from 'app-context/worflow/WorkflowContext';

const isData = [
  { value: 1, label: 'is' },
  { value: 2, label: 'is not' },
  // { value: 3, label: 'greater than' },
  // { value: 4, label: 'greater or equal' },
  // { value: 5, label: 'less than' },
];

const ConditionForm = ({ variableData, id, setWorkflowData, workflowData }) => {
  const formik = useFormikContext();
  const { brandingData } = useBrandingContext();
  const { page_ButtonColor } = brandingData;

  const typeOptions = variableData?.data?.items?.map((item) => ({
    value: item.variableId,
    label: item.variableName,
  }));

  useEffect(() => {
    if (formik.values.workFlowNode_Condition.reassessIntent == true) {
      formik.setFieldValue(
        `workFlowNode_Condition.allOtherConditions.isAllConditions`,
        false
      );
      setWorkflowData((prev) => ({
        ...prev,
        edges: prev.edges.filter(
          (edge) =>
            edge.sourceHandle !==
            formik.values.workFlowNode_Condition.allOtherConditions
              ?.sourceHandle
        ),
      }));
    } else {
      formik.setFieldValue(
        `workFlowNode_Condition.allOtherConditions.isAllConditions`,
        true
      );
    }
  }, [formik.values.workFlowNode_Condition.reassessIntent]);

  return (
    <form
      className={styles['condition-form']}
      onSubmit={formik.handleSubmit}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
        }
      }}
    >
      <Select
        label="Variable"
        placeholder="Select Variable"
        name={`workFlowNode_Condition.variableId`}
        value={formik.values.workFlowNode_Condition.variableId}
        onChange={formik.handleChange}
        error={formik?.errors?.workFlowNode_Condition?.variableId}
        touched={formik?.touched?.workFlowNode_Condition?.variableId}
        options={typeOptions}
      />

      <div className={styles['condition-input']}>
        <div className={styles['field-container']}>
          <div>
            <p className={styles.title}>IF</p>
            <div className={styles['if-container']}>
              <div className={styles['if-input']}>
                <div className={styles['condition']}>
                  <Select
                    name={`workFlowNode_Condition.ifBlock.operationId`}
                    placeholder="Is"
                    selectClassname={styles['common-style']}
                    classname={styles['select2']}
                    options={isData}
                    value={
                      formik.values.workFlowNode_Condition.ifBlock.operationId
                    }
                    onChange={formik.handleChange}
                    // error={formik.errors.workFlowNode_Condition.operationId}
                    // touched={formik.touched.workFlowNode_Condition.operationId}
                  />
                  <Input
                    name={`workFlowNode_Condition.ifBlock.value`}
                    placeholder="enter Value"
                    inputClassname={styles['common-style']}
                    classname={styles['select3']}
                    value={formik.values.workFlowNode_Condition.ifBlock.value}
                    onChange={formik.handleChange}
                    // error={formik.errors.workFlowNode_Condition.value}
                    // touched={formik.touched.workFlowNode_Condition.value}
                  />
                </div>
              </div>
            </div>

            {((formik.errors?.workFlowNode_Condition?.ifBlock?.value &&
              formik.touched?.workFlowNode_Condition?.ifBlock?.value) ||
              (formik.errors?.workFlowNode_Condition?.ifBlock?.operationId &&
                formik.touched?.workFlowNode_Condition?.ifBlock
                  ?.operationId)) && (
              <p className="error-message">Operator and value are required</p>
            )}
          </div>

          {formik.values.workFlowNode_Condition?.elseBlock?.map((q, index) => (
            <div>
              <div className={styles.suggest}>
                <p className={styles.title}>ELSE</p>
                <SvgWithBranding
                  type="delete_table"
                  className={styles.deleteSVG}
                  onClick={() => {
                    const deletedElseBlock =
                      formik.values.workFlowNode_Condition?.elseBlock?.find(
                        (_, i) => i == index
                      );
                    setWorkflowData((prev) => ({
                      ...prev,
                      edges: prev.edges.filter(
                        (edge) =>
                          edge.sourceHandle !== deletedElseBlock?.sourceHandle
                      ),
                    }));
                    const updatedElseIf =
                      formik.values.workFlowNode_Condition?.elseBlock?.filter(
                        (_, i) => i !== index
                      );
                    formik.setFieldValue(
                      'workFlowNode_Condition.elseBlock',
                      updatedElseIf
                    );
                  }}
                />
              </div>
              <div className={styles['if-container']}>
                <div className={styles['if-input']}>
                  <div className={styles['condition']}>
                    <Select
                      name={`workFlowNode_Condition.elseBlock[${index}].operationId`}
                      placeholder="Is"
                      selectClassname={styles['common-style']}
                      classname={styles['select2']}
                      options={isData}
                      value={q.operationId}
                      onChange={formik.handleChange}
                      // error={formik.errors.workFlowNode_Condition.operationId}
                      // touched={formik.touched.workFlowNode_Condition.operationId}
                    />
                    <Input
                      name={`workFlowNode_Condition.elseBlock[${index}].value`}
                      placeholder="enter Value "
                      inputClassname={styles['common-style']}
                      classname={styles['select3']}
                      value={q.value}
                      onChange={formik.handleChange}
                      // error={formik.errors.workFlowNode_Condition.value}
                      // touched={formik.touched.workFlowNode_Condition.value}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
          <div
            className={styles['add-conditions']}
            onClick={() => {
              const existingHandles =
                formik.values.workFlowNode_Condition.elseBlock.map(
                  (block) => block.sourceHandle
                );

              let newIndex = 2;
              while (existingHandles.includes(`${id}-${newIndex}`)) {
                newIndex++;
              }
              formik.setFieldValue('workFlowNode_Condition.elseBlock', [
                ...formik.values.workFlowNode_Condition.elseBlock,
                {
                  value: '',
                  operationId: '',
                  sourceHandle: `${id}-${newIndex}`,
                },
              ]);
            }}
          >
            <SvgWithBranding type="plusSVG" color={page_ButtonColor} />
            <p
              className={styles.title}
              style={{ color: page_ButtonColor, cursor: 'pointer' }}
            >
              {' '}
              Add Condition
            </p>
          </div>

          {!formik.values.workFlowNode_Condition.reassessIntent ? (
            <p className={styles.title}>All Other Conditions</p>
          ) : null}

          <div className={styles.border}></div>

          <div className={styles.suggest}>
            <p className={styles.title}>Reassess Intent</p>
            <Toggle
              name="workFlowNode_Condition.reassessIntent"
              value={
                formik.values.workFlowNode_Condition.reassessIntent || false
              }
              onToggleChange={(e) => {
                formik.setFieldValue(
                  `workFlowNode_Condition.reassessIntent`,
                  !formik.values.workFlowNode_Condition.reassessIntent
                );

                formik.setFieldValue(
                  `workFlowNode_Condition.allOtherConditions.isAllConditions`,
                  !formik.values.workFlowNode_Condition.allOtherConditions
                    .isAllConditions
                );
              }}
            />
          </div>
        </div>
      </div>
    </form>
  );
};

export default ConditionForm;
